/**
 * XSS Validierung
 *
 */
export class OpaccXssValidator {
	constructor(form) {
		this.form = form;
	}

	/**
	 *
	 *
	 * @returns {*}
	 */
	htmlEncodeXssFields() {
		let attribute = this.form.getAttribute('data-op-no-xss');
		if (attribute !== '1') {
			return;
		}

		let fields = this.form.querySelectorAll('[data-op-no-xss="1"]');
		if (fields.length == 0) {
			return;
		}

		Array.from(fields).forEach(field => {
			field.value = this.htmlEncode(field.value);
		});
	}

	/**
	 *
	 *
	 * @param {*} text
	 * @returns {*}
	 */
	htmlDecode(text) {
		let div = document.createElement('div');
		div.innerHTML = text;
		return ('textContent' in div) ? div.textContent : div.innerText;
	}

	/**
	 *
	 *
	 * @param {*} str
	 * @returns {*}
	 */
	htmlEncode(str) {
		let div = document.createElement('div');
		div[('textContent' in div) ? 'textContent' : 'innerText'] = str;
		return div.innerHTML;
	}
}